@if (trixelUrl()) {
  <rma-trixel [trixelImgUrl]="trixelUrl()" />
}

<img
  rmaBrokenImage
  class="h-full w-full object-cover"
  [style.background-color]="backgroundColour()"
  [ngSrc]="avatar() || placeholderImage()"
  [alt]="name() ?? 'placeholder'"
  [priority]="lazyLoad() ? false : true"
  [loaderParams]="{ transformations: transformations() }"
  disableOptimizedSrcset="true"
  fill
/>
